import Vue from "vue";
import Router from "vue-router";
import Index from "./views/Index.vue";
import Result from "./views/Result.vue";
import Favorite from "./views/Favorite.vue";
import Help from "./views/Help.vue";
import Admin from "./views/Admin.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "index",
      component: Index
    },
    {
      path: "/redirect",
      redirect: "/"
    },
    {
      path: "/result/:jan",
      name: "result",
      component: Result,
      props: true
    },
    {
      path: "/favorite",
      name: "favorite",
      component: Favorite
    },
    {
      path: "/help",
      name: "help",
      component: Help
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin
    }
  ]
});
